'use client';
/*
 *  @providesModule WebDeepLinkHandler
 *
 */
import {_m} from 'INTL';
import SkillzRouter from 'SkillzRouter';
import TournamentManager from 'TournamentManager';
import SKZTournament from 'SKZTournament';

//@ts-ignore
import {NativeModules} from 'react-native';

const SkillzModule = NativeModules.SkillzModule;
const GAME_ID = SkillzModule.App.GameId;

const WebDeepLinkHandler = {
  //function to check if the macthCode in deep link is valid
  async checkDeepLink(): Promise<boolean> {
    if (typeof window === 'undefined' || !window.location) return false; //prevent error for non-browser environment

    const routerQuery = new URLSearchParams(window.location.search);
    const matchCode = routerQuery.get('match_code');
    if (matchCode) {
      try {
        const tournament = await new Promise<SKZTournament | null>((resolve, reject) => {
          TournamentManager.fetchTournamentForCode(
            matchCode,
            false,
            false,
            (error?: string, tournament?: SKZTournament) => {
              if (error || !tournament?.live_event?.id) {
                console.error('MC: Error fetching tournament:', error);
                reject(error || 'Tournament not found');
              } else {
                resolve(tournament);
              }
            }
          );
        });
        return Boolean(tournament);
      } catch (error) {
        console.error('Error handling deep link:', error);
        return false;
      }
    } else {
      return false;
    }
  },

  async checkAndHandleDeepLink(): Promise<boolean> {
    if (typeof window === 'undefined' || !window.location) return false; //prevent error for non-browser environment
    // Parse and validate the deep link URL
    const routerQuery = new URLSearchParams(window.location.search);
    const matchCode = routerQuery.get('match_code');
    if (matchCode) {
      const result = await this.handleLiveEventWithCode(matchCode);
      return result;

      // If in the future we decide to support limited time offers via deep links,
      // we can uncomment the following block anf use the same way to handle the 'lto' query parameter:
      // } else if (routerQuery.get('lto')) {
      //   this.handleLTOOffer();
      //   return true;

      // Similarly, if in the future we want to handle deposit offers via deep links,
      // we can uncomment and implement this block to process the 'depositOffer' parameter:
      // } else if (routerQuery.get('depositOffer')) {
      //   this.handleDepositOffer();
      //   return true;
    } else {
      return false;
    }
  },
  async handleLiveEventWithCode(matchCode: string): Promise<boolean> {
    try {
      // Fetch the tournament data asynchronously by wrapping the callback in a Promise
      const tournament = await new Promise<SKZTournament | null>((resolve, reject) => {
        TournamentManager.fetchTournamentForCode(
          matchCode,
          false,
          false,
          (error?: string, tournament?: SKZTournament) => {
            if (error || !tournament?.live_event?.id) {
              console.error('MC: Error fetching tournament:', error);
              reject(error || 'Tournament not found');
            } else {
              resolve(tournament);
            }
          }
        );
      });

      // If tournament data is available, navigate to the live event
      if (tournament) {
        // Navigate to BRACKETS_V2 for live brackets
        if (tournament.isLiveBracket()) {
          SkillzRouter.replace(`/games/${GAME_ID}/brackets-v2`, {
            tournament,
            matchCode,
            hideOrientationFlip: true,
            isFromPlayTab: true,
            isSkipRerender: true,
          });
        } else {
          SkillzRouter.replace(`/games/${GAME_ID}/live-event/${tournament.live_event?.id}`, {
            tournamentSource: tournament,
            matchCode,
            hideOrientationFlip: true,
            isFromPlayTab: true,
            isSkipRerender: true,
          });
        }

        return true; // Success
      }
    } catch (error) {
      console.error('Error handling deep link:', error);
      return false; // Return false if there was an error
    }
  },
};

export default WebDeepLinkHandler;
